import React from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";

import { useConfiguration } from "../../context/configurationContext";

import { injectIntl, intlShape } from "../../util/reactIntl";
import { propTypes } from "../../util/types";
import { ensureCurrentUser } from "../../util/data";

import { sendVerificationEmail } from "../../ducks/user.duck";
import { isScrollingDisabled } from "../../ducks/ui.duck";

import { H3, Page, UserNav, LayoutSideNavigation } from "../../components";

import TopbarContainer from "../TopbarContainer/TopbarContainer";
import FooterContainer from "../FooterContainer/FooterContainer";
import NotificationPreferencesForm from "./NotificationPreferencesForm/NotificationPreferencesForm";

import css from "./NotificationPreferencesPage.module.css";

export const NotificationPreferencesPageComponent = (props) => {
  const config = useConfiguration();
  const { currentUser, onChange, scrollingDisabled } = props;
  const { userTypes = [] } = config.user;

  const user = ensureCurrentUser(currentUser);
  const publicData = user.attributes.profile.publicData || {};
  const userType = publicData?.userType;
  const userTypeConfig =
    userType && userTypes.find((config) => config.userType === userType);

  const handleSubmit = async (values) => {
    console.log("values", values);
    // change user sms notification settings
    await fetch(
      `${process.env.REACT_APP_INSTAGROOMS_CORE_URL}/update-notification-preferences`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: user.id.uuid,
          smsNotifications: values.smsNotifications,
          emailNotifications: {
            draftListingsNotifications: values.draftListingsNotifications,
          },
        }),
        credentials: "include",
      }
    ).then((response) => {
      if (response.ok) {
        console.log("SMS notification settings updated successfully");
        window.location.reload();
      } else {
        console.error("Failed to update SMS notification settings");
      }
    });

    return;
  };

  const contactInfoForm = user.id ? (
    <NotificationPreferencesForm
      className={css.form}
      initialValues={{}}
      currentUser={currentUser}
      onSubmit={handleSubmit}
      onChange={onChange}
      userTypeConfig={userTypeConfig}
    />
  ) : (
    <h1>Loading...</h1>
  );

  const title = "NotificationPreferencesPage";

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSideNavigation
        topbar={
          <>
            <TopbarContainer
              desktopClassName={css.desktopTopbar}
              mobileClassName={css.mobileTopbar}
            />
            <UserNav currentPage="NotificationPreferencesPage" />
          </>
        }
        sideNav={null}
        useAccountSettingsNav
        currentPage="NotificationPreferencesPage"
        footer={<FooterContainer />}
      >
        <div className={css.content}>
          <H3 as="h1">Notifications</H3>
          {contactInfoForm}
        </div>
      </LayoutSideNavigation>
    </Page>
  );
};

NotificationPreferencesPageComponent.defaultProps = {
  currentUser: null,
};

const { bool, func } = PropTypes;

NotificationPreferencesPageComponent.propTypes = {
  currentUser: propTypes.currentUser,
  onChange: func.isRequired,
  onSubmitContactDetails: func.isRequired,
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
  // Topbar needs user info.
  const { currentUser } = state.user;
  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onChange: () => dispatch(saveContactDetailsClear()),
  onResendVerificationEmail: () => dispatch(sendVerificationEmail()),
  onSubmitContactDetails: (values) => dispatch(saveContactDetails(values)),
});

const NotificationPreferencesPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(NotificationPreferencesPageComponent);

export default NotificationPreferencesPage;
